import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LeaveAdminStoreService } from '@core/services/leave-admin-store.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { closeDialogOnEscape } from '@shared/helpers';

@Component({
    selector: 'app-pending-actions-alert',
    templateUrl: './pending-actions-alert.component.html',
    styleUrl: './pending-actions-alert.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PendingActionsAlertComponent {
  static readonly componentName = 'PendingActionsAlertComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;
  public actionsCount: number;
  public sysText: any;

  private destroy$: Subject<void> = new Subject<void>();

  constructor (
    private dialogRef: MatDialogRef<PendingActionsAlertComponent>,
    private storeService: LeaveAdminStoreService,
  ) { }

  ngOnInit() {
    closeDialogOnEscape(this.dialogRef, null, () => this.dialogRef.close(false));

    this.sysText = this.storeService.sysText[this.storeService.templates.pendingChanges];
    this.actionsCount = (this.storeService.actionQue.length + 1);
    this.storeService.actionSubmitting
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res == null && !this.storeService.isActionRunning) {
          // short delay before closing to avoid alert 
          // 'flashing' for a fraction of a second
          setTimeout(() => {
            this.dialogRef.close(true);
          }, 0)
        }
        this.actionsCount = this.storeService.actionQue.length;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
